var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.66279C0 1.91581 1.41581 0.5 3.16279 0.5H12.8372C14.5842 0.5 16 1.91581 16 3.66279V13.3372C16 15.0842 14.5842 16.5 12.8372 16.5H3.16279C1.41581 16.5 0 15.0842 0 13.3372V3.66279ZM11.7433 6.66186C11.9619 6.44419 11.9619 6.0907 11.7433 5.87302C11.5256 5.65442 11.1721 5.65442 10.9544 5.87302L6.88372 9.94279L5.04558 8.10558C4.82791 7.88698 4.47442 7.88698 4.25674 8.10558C4.03814 8.32326 4.03814 8.67674 4.25674 8.89442L6.4893 11.127C6.70698 11.3456 7.06046 11.3456 7.27814 11.127L11.7433 6.66186Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.25dd7098c601c5a9cb9139041fbe80a5.svg";
export { ForwardRef as ReactComponent };